import { Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Img1 from "./termConditionImg/term1.jpeg";
import Img2 from "./termConditionImg/term2.jpeg";
import Img3 from "./termConditionImg/term3.jpeg";
import CertificateCard from "../CertificateCard/CertificateCard";

const RefundPolicy = () => {
  // Scroll to top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <main>
        <Stack
          sx={{
            height: "auto",
            display: "flex",
            flexDirection: { xl: "row" },
            justifyContent: "center",
            // border: "1px solid blue",
          }}
        >
          <Stack sx={{ width: { xl: "70%" } }}>
            {/* Header Section */}

            <Stack
              sx={{
                marginTop: "20px",
                // border: "1px solid blue",
                height: { xl: "14%" },
                dispaly: "flex",
                flexDirection: { xl: "column" },
              }}
            >
              <Stack
                sx={{
                  // border: "2px solid red",
                  height: { xl: "60%" },
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xl: "40px" },
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    fontWeight: 600,
                  }}
                >
                  Refund Policy
                </Typography>
              </Stack>
              <Stack
                sx={{
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  // border: "1px solid red",
                }}
              >
                <Stack
                  sx={{
                    dispaly: "flex",
                    flexDirection: {
                      xl: "row",
                      lg: "row",
                      md: "row",
                      sm: "row",
                      xs: "column",
                    },
                    alignItems: "center",
                    justifyContent: "space-between",
                    // border: "2px solid red",
                    width: {
                      xl: "40%",
                      lg: "50%",
                      md: "50%",
                      sm: "50%",
                      xs: "100%",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xl: "12px", xs: "12px" },
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 400,
                    }}
                  >
                    Effective Date: August 3rd, 2021
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xl: "12px", xs: "12px" },
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 400,
                    }}
                  >
                    Last Updated on: January 1st, 2025
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                sx={{
                  // border: "2px solid blue",
                  height: { xl: "30%" },
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Breadcrumbs
                  aria-label="breadcrumb"
                  sx={{ marginLeft: "12px" }}
                >
                  <Link
                    underline="hover"
                    color="inherit"
                    href="/"
                    sx={{
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 600,
                    }}
                  >
                    Home
                  </Link>
                  <Link underline="none" color="inherit">
                    Refund Policy
                  </Link>
                </Breadcrumbs>
              </Stack>
            </Stack>

            {/* Cotent Section */}

            <Stack
              sx={{
                marginTop: "60px",
                // border: "3px solid green",
                dispaly: "flex",
                flexDirection: {
                  xl: "row",
                  lg: "row",
                  md: "row",
                  sm: "row",
                  xs: "column",
                },
                justifyContent: "space-between",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "70%", lg: "70%", md: "70%", sm: "70%" },
                  // border: "1px solid blue",
                  border: "1px solid #d1d1d1",
                  borderRadius: "8px",
                  padding: "16px",
                  backgroundColor: "#fff",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  color: "#333",
                  lineHeight: "1.6",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  overflow: "hidden",
                }}
              >
                <p
                  style={{
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  At Vertex Suite, we are committed to providing you with
                  exceptional SaaS solutions, ensuring your experience is
                  seamless and satisfactory. Our refund policy is designed to be
                  transparent, fairand customer-centric. Please take a moment
                  to read and understand our policy.
                </p>

                {/* Section 1 */}
                <h2
                  style={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    marginBottom: "8px",
                    color: "#000",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Customer Satisfaction is Our Priority
                </h2>
                <hr
                  style={{ border: "1px solid #ddd", marginBottom: "16px" }}
                />
                <p
                  style={{
                    marginBottom: "24px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  We value your trust in our services. If you find yourself
                  dissatisfied within the first 7 days of your subscription, we
                  are here to address your concerns.
                </p>

                {/* Section 2 */}
                <h2
                  style={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    marginBottom: "8px",
                    color: "#000",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Eligibility Criteria for Refund
                </h2>
                <hr
                  style={{ border: "1px solid #0073e6", marginBottom: "16px" }}
                />
                <p
                  style={{
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  To be eligible for a refund, please ensure:
                </p>
                <ul style={{ marginLeft: "20px", marginBottom: "24px" }}>
                  <li
                    style={{
                      marginBottom: "8px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    Refund requests are made within 7 days of your initial
                    subscription.
                  </li>
                  <li
                    style={{
                      marginBottom: "8px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    The reason for the refund is directly related to the
                    performance or functionality of our platform.
                  </li>
                </ul>

                {/* Section 3 */}
                <h2
                  style={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    marginBottom: "8px",
                    color: "#000",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Refund Request Process
                </h2>
                <hr
                  style={{ border: "1px solid #0073e6", marginBottom: "16px" }}
                />
                <p
                  style={{
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Although we aim to help our customers as much as possible,
                  there are cases where we can't offer refunds:
                </p>
                <ul style={{ marginLeft: "20px" }}>
                  <li
                    style={{
                      marginBottom: "8px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    In the event that the refund request is submitted beyond the
                    30-day window.
                  </li>
                  <li
                    style={{
                      marginBottom: "8px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    If the concerns expressed fall outside the purview of what
                    our SaaS platform can do.
                  </li>
                  <li
                    style={{
                      marginBottom: "8px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    Should our terms of service be broken.
                  </li>
                </ul>

                {/* Section 4 */}
                <h2
                  style={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    marginBottom: "8px",
                    color: "#000",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Exceptions to Refund Policy
                </h2>
                <hr
                  style={{ border: "1px solid #0073e6", marginBottom: "16px" }}
                />
                <p
                  style={{
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Although we aim to accommodate our customers, there are
                  instances where refunds may not be given:
                </p>
                <ul style={{ marginLeft: "20px" }}>
                  <li
                    style={{
                      marginBottom: "8px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    Requests made after the 7 day period.
                  </li>
                  <li
                    style={{
                      marginBottom: "8px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    Issues beyond the scope of our platform's functionality.
                  </li>
                  <li
                    style={{
                      marginBottom: "8px",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    Violation of our Terms of Service.
                  </li>
                </ul>

                {/* Section 5 */}
                <h2
                  style={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    marginBottom: "8px",
                    color: "#000",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Cancellation without refund
                </h2>
                <hr
                  style={{ border: "1px solid #0073e6", marginBottom: "16px" }}
                />
                <p
                  style={{
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Customers have the facility to cancel the subscription at any
                  time. However, please note that after the initial 7 days,
                  refunds will not be provided. And if membership is canceled
                  within 7 days, refund will be considered.
                </p>

                {/* Section 6 */}
                <h2
                  style={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    marginBottom: "8px",
                    color: "#000",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Meta Policy and Account Responsibility
                </h2>
                <hr
                  style={{ border: "1px solid #0073e6", marginBottom: "16px" }}
                />
                <p
                  style={{
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  It's important to note that we are not responsible for issues
                  related to Meta policy enforcement. In cases where Meta
                  policies impact your account, including potential account
                  disablement, we advise adhering to Meta's guidelines. We are
                  not liable for any disruption caused by Meta policy
                  enforcement.
                </p>

                {/* Section 7 */}
                <h2
                  style={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    marginBottom: "8px",
                    color: "#000",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Contact Us
                </h2>
                <hr
                  style={{ border: "1px solid #0073e6", marginBottom: "16px" }}
                />
                <p
                  style={{
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  For any queries regarding our refund policy or support, please
                  contact us at (mailto:management.vertexsuite@gmail.com). We're
                  here to help.
                </p>

                {/* Section 8 */}
                <h2
                  style={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    marginBottom: "8px",
                    color: "#000",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Policy Updates
                </h2>
                <hr
                  style={{ border: "1px solid #0073e6", marginBottom: "16px" }}
                />
                <p
                  style={{
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Vertex Suite reserves the right to update, modify, or change
                  this refund policy at any time. Any changes will be effective
                  immediately and will be communicated to our customers through
                  our official communication channels.
                </p>
                <p
                  style={{
                    marginBottom: "16px",
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  }}
                >
                  Thank you for choosing Vertex Suite. We appreciate the trust
                  you place in our SaaS platformand we are dedicated to
                  delivering value and excellence in every aspect of our
                  service.
                </p>
              </Stack>
              <Stack
                sx={{
                  width: { xl: "30%", lg: "30%", md: "30%", sm: "30%" },
                  // border: "1px solid red",
                  dispaly: "flex",
                  flexDirection: "column",
                }}
              >
                <Stack
                  sx={{
                    border: "none",
                    width: "100%",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                    lineHeight: "1.8",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    CATEGORIES
                  </h3>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Blog
                    </li>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Inventory & Order Management
                    </li>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Multi-Vendor
                    </li>
                    <li
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#0073e6"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#333"; // Default color
                      }}
                    >
                      Social Commerce
                    </li>
                  </ul>
                  <Stack
                    sx={{
                      borderTop: "1px solid #ddd",
                      marginBottom: "20px",
                      width: { xl: "80%" },
                    }}
                  ></Stack>
                </Stack>
                <Stack
                  sx={{
                    border: "none",
                    width: "300px",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                    lineHeight: "1.6",
                    backgroundColor: "#fff",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      // borderBottom: "1px solid #ddd",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    RECENT POSTS
                  </h3>

                  {/* Post 1 */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <img
                      src={Img1}
                      alt="Post 1"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          margin: "0 0 8px 0",
                          fontWeight: "bold",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Setup and Operational Costs for WhatsApp Business API:
                        Key Dependencies
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          color: "#777",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        November 21, 2024 &nbsp;&nbsp; No Comments
                      </p>
                    </div>
                  </Stack>

                  {/* Post 2 */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <img
                      src={Img2}
                      alt="Post 2"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          margin: "0 0 8px 0",
                          fontWeight: "bold",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        Why WhatsApp Business API Policies Matter?
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          color: "#777",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        November 20, 2024 &nbsp;&nbsp; No Comments
                      </p>
                    </div>
                  </Stack>

                  {/* Post 3 */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <img
                      src={Img3}
                      alt="Post 3"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <h4
                        style={{
                          fontSize: "16px",
                          margin: "0 0 8px 0",
                          fontWeight: "bold",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#0073e6"; // Hover color
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#333"; // Default color
                        }}
                      >
                        WhatsApp Business API top features
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          color: "#777",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        November 20, 2024 &nbsp;&nbsp; No Comments
                      </p>
                    </div>
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    width: "100%",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    OUR INSTAGRAM
                  </h3>
                  <Stack direction="row" spacing={2}>
                    {/* Card 1 */}
                    <div
                      style={{
                        width: "120px",
                        height: "120px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        transition: "background-color 0.3s ease",
                        backgroundColor: "#f7f4e6", // Matching the background of the first card
                        borderBottom: "1px solid #ddd",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.border = "2px solid #ffffff";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.border = "transparent";
                      }}
                    >
                      <img
                        src={Img1}
                        alt="Instagram Post 1"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>

                    {/* Card 2 */}
                    <div
                      style={{
                        width: "120px",
                        height: "120px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        transition: "background-color 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.border = "2px solid #ffffff";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.border = "transparent";
                      }}
                    >
                      <img
                        src={Img2}
                        alt="Instagram Post 2"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    width: "300px",
                    padding: "16px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#333",
                    lineHeight: "1.6",
                  }}
                >
                  <Stack
                    sx={{ borderTop: "1px solid #ddd", marginBottom: "60px" }}
                  ></Stack>
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginBottom: "16px",
                      color: "#000",
                    }}
                  >
                    RECENT COMMENTS
                  </h3>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {/* Comment 1 */}

                    <li style={{ marginBottom: "16px" }}>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        <span style={{ fontWeight: "bold" }}>vinod gupta</span>{" "}
                        on{" "}
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#0073e6",
                            fontWeight: "normal",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Send 1000 bulk messages on WhatsApp | WhatsApp bulk
                          sender
                        </a>
                      </span>
                    </li>

                    {/* Comment 2 */}
                    <li style={{ marginBottom: "16px" }}>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Top 10 Business Fields Where
                        </span>{" "}
                        on{" "}
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#0073e6",
                            fontWeight: "normal",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          WhatsApp Business API Can Facilitate Growth - Vertex
                          Suite on Tips for Effective Messaging on WhatsApp
                        </a>
                      </span>
                    </li>

                    {/* Comment 3 */}
                    <li style={{ marginBottom: "16px" }}>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        <span
                          style={{
                            fontWeight: "bold",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Documents Required for
                        </span>{" "}
                        on{" "}
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            color: "#0073e6",
                            fontWeight: "normal",
                            fontFamily:
                              "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                          }}
                        >
                          Integrating WhatsApp Business API into Your Business -
                          Vertex Suite on WhatsApp E-commerce Store
                        </a>
                      </span>
                    </li>
                  </ul>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </main>
      <CertificateCard />
      <Footer />
    </>
  );
};

export default RefundPolicy;
